import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

import {
  bulkAddFetch,
  bulkAddFetchFailure,
  bulkAddFetchSuccess,
  bulkAddInit,
  bulkAddItems,
  bulkAddItemsFailure,
  bulkAddItemsSuccess,
} from '../../actions';

export const productListBulkAddFeatureKey = 'bulkAdd';

export interface State extends EntityState<Product> {
  loadingProducts: boolean;
  loadingProductsFailure: boolean;
  adding: boolean;
  addingFailure: boolean;
}

export const adapter: EntityAdapter<Product> = createEntityAdapter<Product>({
  selectId: ({ productId }: Product) => productId,
});

export const initialState: State = adapter.getInitialState({
  loadingProductsFailure: false,
  loadingProducts: false,
  adding: false,
  addingFailure: false,
});

export const reducer = createReducer(
  initialState,
  on(bulkAddInit, () => initialState),

  on(bulkAddFetch, (state) => ({
    ...state,
    loadingProducts: true,
  })),
  on(bulkAddFetchSuccess, (state, { products }) =>
    adapter.upsertMany(
      products
        .map((item) => item.product)
        .filter((item) => !!item) as Product[],
      {
        ...state,
        loadingProducts: false,
        loadingProductsFailure: false,
      },
    ),
  ),
  on(bulkAddFetchFailure, (state) => ({
    ...state,
    loadingProducts: false,
    loadingProductsFailure: true,
  })),

  on(bulkAddItems, (state) => ({ ...state, adding: true })),
  on(bulkAddItemsSuccess, (state) => ({
    ...state,
    adding: false,
    addingFailure: false,
  })),
  on(bulkAddItemsFailure, (state) => ({
    ...state,
    adding: false,
    addingFailure: true,
  })),
);
